import ListItem from '@mui/material/ListItem'
import Box from '@mui/material/Box'
import { useLocation, useNavigate } from 'react-router-dom'

const AppMenuItemComponent = props => {
  const { sx, onClick, link, children, route, toggleDrawer, onSectionSelect } = props

  const location = useLocation()
  const navigate = useNavigate()

  // If a route is provided, navigate to that route when clicked (SPA navigation)
  if (route && typeof route === 'string') {
    const handleNavigate = (e) => {
      if (onClick) onClick(e)
      navigate(route)
      // Close the drawer if a toggleDrawer function was provided by the parent
      if (toggleDrawer && typeof toggleDrawer === 'function') {
        const closeHandler = toggleDrawer(false)
        if (typeof closeHandler === 'function') {
          closeHandler(e)
        }
      }
    }
    return (
      <Box>
        <ListItem button sx={sx} onClick={handleNavigate}>
          {children}
        </ListItem>
      </Box>
    )
  }

  // If link is not set return the ordinary ListItem (expandable items)
  if (!link || typeof link !== 'string') {
    const handleClickDefault = (e) => {
      if (onClick) onClick(e)  // This is for expandable items - just toggle for sumenue i.e expandable, don't close drawer
    }

    return (
      <ListItem
        sx={sx}
        onClick={handleClickDefault}
      >
        {children}
      </ListItem>
    )
  }

  // On the homepage, wait for the drawer to close before scrolling to the section.
if (location.pathname === '/' || location.pathname === '') {
  const handleClickScroll = (e) => {
    if (onClick) onClick(e)
    if (toggleDrawer && typeof toggleDrawer === 'function') {
      const closeHandler = toggleDrawer(false)
      if (typeof closeHandler === 'function') {
        closeHandler(e)
      }
    }
    if (onSectionSelect) onSectionSelect(link)
  }

  return (
    <Box>
      <ListItem
        button
        sx={sx}
        onClick={(e) => {
          handleClickScroll(e)
        }}
      >
        {children}
      </ListItem>
    </Box>
  )
}

  // If we're on another route (like /age-calculator), navigate to home and pass the target section
  // in location.state so Home can scroll to it after navigation.
const handleNavigateToHome = (e) => {
  if (onClick) onClick(e)
  navigate('/', { state: { scrollTo: link } })

  if (toggleDrawer && typeof toggleDrawer === 'function') {
    const closeHandler = toggleDrawer(false)
    if (typeof closeHandler === 'function') {
      closeHandler(e)
    }
  }
}

  return (
    <Box>
      <ListItem button sx={sx} onClick={handleNavigateToHome}>
        {children}
      </ListItem>
    </Box>
  )
}

export default AppMenuItemComponent
